import { render, staticRenderFns } from "./ReturnGoods.vue?vue&type=template&id=110d2bac&scoped=true&"
import script from "./ReturnGoods.vue?vue&type=script&lang=js&"
export * from "./ReturnGoods.vue?vue&type=script&lang=js&"
import style0 from "./ReturnGoods.vue?vue&type=style&index=0&id=110d2bac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110d2bac",
  null
  
)

export default component.exports